import userInfoStore from "@/store/user.store";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import { useEffect, useMemo } from "react";

const useGetDisplayUserInfo = () => {
  const avatar = userInfoStore((state) => state.avatar);
  const displayName = userInfoStore((state) => state.displayName);
  const mobile = userInfoStore((state) => state.mobile);
  const identityType = userInfoStore((state) => state.company.identityType);
  const companyName = userInfoStore((state) => state.company.companyName);
  const companyRealName = userInfoStore((state) => state.company.realname);
  const companyAvatar = userInfoStore((state) => state.company.avatar);

  const displayUserInfo = useMemo(() => {
    const formatUserName =
      displayName || `用户${mobile ? mobile.slice(-4) : ""}`;
    const speakerAvatarInfo = getSpeakerAvatarInfo(avatar);
    return {
      displayName: formatUserName,
      identityType: identityType,
      companyRealName: companyRealName,
      companyName: companyName,
      avatarUrl: identityType === 0 ? speakerAvatarInfo.avatarUrl : companyAvatar,
      avatarIndex: speakerAvatarInfo.avatarIndex || 0,
    };
  }, [avatar, companyRealName, companyAvatar, companyName, displayName, identityType, mobile]);

  useEffect(() => {
    userInfoStore.getState().updateUserInfo({ formatUserName: displayUserInfo.displayName });
  }, [displayUserInfo.displayName]);

  return {
    displayUserInfo,
  };
};

export default useGetDisplayUserInfo;
